import { useEffect, useState } from "react";

import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Modal } from "@/components/ui/Modal";

interface Props {
  open: boolean;
  title: string;
  label: string;
  initialValue?: string;
  submitting?: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
}

/** Small single-field modal used for "new folder" and "rename". */
export function NameDialog({
  open,
  title,
  label,
  initialValue = "",
  submitting,
  onClose,
  onSubmit,
}: Props) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (open) setValue(initialValue);
  }, [open, initialValue]);

  function submit() {
    const trimmed = value.trim();
    if (trimmed) onSubmit(trimmed);
  }

  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <div className="flex flex-col gap-4">
        <Input
          label={label}
          value={value}
          autoFocus
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Anuluj
          </Button>
          <Button onClick={submit} loading={submitting} disabled={!value.trim()}>
            Zapisz
          </Button>
        </div>
      </div>
    </Modal>
  );
}
